import { Key, ReactNode } from 'react'

import { Table } from 'antd'

declare type Position = 'top' | 'bottom' | 'both'
declare type Layout = 'fixed' | 'auto'
declare type Size = 'default' | 'middle' | 'small'
declare type Align = 'left' | 'right' | 'center'

interface TableProps {
  columns: ColumnProps[]
  data: DataProps[]
  layout?: Layout
  size?: Size
  bordered?: boolean
  rowSelection?: RowSelectionProps
  loading?: boolean
  pagination?: PaginationProps
  expandedRowRender?: (record: DataProps, index: number, indent: number, expanded: boolean) => ReactNode
  onSortChange?: (sorter: any) => void
  onFilterChange?: (filter: Partial<Record<keyof DataProps, string[]>>) => void
  onPaginationChange?: (pagination: PaginationProps) => void
}

export interface ColumnProps {
  title: string
  key: Key
  dataIndex: string
  align?: Align
  sorter?: boolean
  filters?: ColumnFilterItem[]
  render?: (text: any, record: any, index: number) => ReactNode
}

interface ColumnFilterItem {
  text: ReactNode
  value: string
}

export interface DataProps {
  key: string
  [x: string]: any
}

export interface RowSelectionProps {
  onChange?: (selectedRowKeys: string[] | number[], selectedRows: DataProps[]) => void
  getCheckboxProps?: (record: any) => object
  selectedRowKeys?: string[] | number[]
}

export interface PaginationProps {
  autoPagination: boolean
  position?: Position
  total?: number
  disabled?: boolean
  current?: number
  defaultPageSize?: number
  pageSize?: number
}

/**
 * @deprecated The method should not be used. Please use TableV2 instead.
 */
const Display = (props: TableProps) => {
  let pagination: any | false = false
  if (props.pagination) {
    if (props.pagination.autoPagination) {
      pagination = {
        position: props.pagination.position,
        defaultPageSize: props.pagination.defaultPageSize,
      }
    } else {
      pagination = { ...props.pagination }
    }
  }

  return (
    <Table
      tableLayout={props.layout}
      bordered={props.bordered}
      loading={props.loading}
      rowSelection={props.rowSelection}
      expandedRowRender={props.expandedRowRender}
      pagination={pagination}
      columns={props.columns}
      dataSource={props.data}
      onChange={(pagination: any, filters: any, sorter) => {
        //TODO - Handle all unnecessary calls in cases where one or more objects hasn't any change in their properties
        if (props.onPaginationChange) {
          props.onPaginationChange({
            autoPagination: props.pagination?.autoPagination ? props.pagination?.autoPagination : true,
            ...pagination,
          })
        }
        if (props.onFilterChange) {
          props.onFilterChange(filters)
        }
        if (props.onSortChange) {
          props.onSortChange(sorter)
        }
      }}
    />
  )
}

export default Display
